module.exports = __webpack_public_path__ + "img/thumbnail_SussexChicken_m_normal.c3e219bc.png";